<template>
    <div>
        <v-overlay v-if="loading" color="black" style="z-index: 2000;">
            <v-progress-circular indeterminate/>
        </v-overlay>
        <div style="display: flex" class="mb-4">
            <v-btn v-if="showBackButton" icon color="secondary" @click="goBack">
                <v-icon small>fa-arrow-left</v-icon>
            </v-btn>
            <v-btn v-if="showRefreshButton" icon color="secondary" @click="refreshGrid"
                   :disabled="disableRefreshButton">
                <v-icon small>fa-arrows-rotate</v-icon>
            </v-btn>
            <slot name="additionalMainActions">

            </slot>
            <v-btn v-if="canCreate" class="ml-2" icon color="primary" @click="addItem">
                <v-icon large class="mr-2">fa-plus-circle</v-icon>
            </v-btn>

            <v-spacer/>
            <slot name="additionalFilterActions">

            </slot>
            <v-text-field
                dense
                :label="searchLabel"
                ref="searchField"
                :auto-grow="false"
                row="1"
                clear-icon="far fa-times-circle"
                clearable
                hide-details
                color="#646464"
                v-model="filter"
                class="mt-2 mx-2"
                style="width: 0; width:100%; max-width: 500px"
            >
                <template #append-outer>
                    <v-icon color="#646464" small>
                        fa-search
                    </v-icon>
                </template>
            </v-text-field>
        </div>
        <aprocon-table
            ref="table"
            class="mb-8"
            :service-url="$store.getters['Auth/serviceUrl']"
            :user-id="$store.getters['Auth/userId']"
            :auth-token="$store.getters['Auth/authToken']"
            :table-name="gridName"
            :context="gridContext"
            :override-config="overrideConfig"
            :errorHandler="errorHandler"
            :filterExpression="filterExpression"
            :filter="filter"
            @update:activeTab="tabChanged"
            @edit="editItem"
            @delete="deleteItem"
            @formLoaded="formLoaded"
            :form-mapper="formMappingProvider"
            :formContext="simpleFormContext"
            :formContextByFormName="formContext()"
            :parent-record-id="parentRecordId"
            :parent-data="parentRecord"
            @formClosed="formClosed"
        >
            <template #form-loading>
                <v-layout justify-center align-center fill-height>
                    <v-progress-circular style="" indeterminate/>
                </v-layout>
            </template>
            <template
                #EDIT_FILIALAUFTRAEGE-buttons="{valid, save, cancel, action}">
                <v-row style="margin: 0; padding: 0;">

                    <v-spacer/>
                    <v-btn @click="cancel"
                           class="mr-2 aprocon-form--button aprocon-form--button-secondary">
                        <!--                        <v-icon small dark>fa-times</v-icon>-->
                        <span class="ml-2">Abbrechen</span>
                    </v-btn>
                    <v-btn class="aprocon-form--button aprocon-form--button-primary"
                           @click="saveCustomerOrder(save)"
                           :disabled="!valid">
                        <!--                        <v-icon small dark>fa-floppy-disk</v-icon>-->
                        <span v-if="action=='Update'" class="ml-2">Speichern</span>
                        <span v-else class="ml-2">Erstellen</span>
                    </v-btn>
                </v-row>
            </template>
            <template
                #EDIT_FILIALBESTELLUNGEN-buttons="{valid, changed, save, cancel, value, action}">
                <v-row style="margin: 0; padding: 0;">
                    <v-btn :disabled="!valid || !canSend(value)"
                           @click="sendOrder(changed,value, save, cancel)"
                           class="mr-2 aprocon-form--button aprocon-form--button-secondary aprocon-green-light">
                        <v-icon small dark>ordermanager-paper-plane-empty</v-icon>
                        <span class="ml-2">Abschicken</span>
                    </v-btn>
                    <v-btn @click="printOrder(changed,value,cancel)"
                           :disabled="!valid || !canPrint(value)"
                           class="mr-2 aprocon-form--button aprocon-form--button-secondary">
                        <v-icon small dark>ordermanager-file-pdf</v-icon>
                        <span class="ml-2">Drucken</span>
                    </v-btn>
                    <v-spacer/>
                    <v-btn @click="cancel"
                           class="mr-2 aprocon-form--button aprocon-form--button-secondary">
                        <!--                        <v-icon small dark>fa-times</v-icon>-->
                        <span class="ml-2">Abbrechen</span>
                    </v-btn>
                    <v-btn class="aprocon-form--button aprocon-form--button-primary"
                           @click="saveOrder(save, action,value)"
                           :disabled="!valid || !canPrint(value)">
                        <!--                        <v-icon small dark>fa-floppy-disk</v-icon>-->
                        <span v-if="action=='Update'" class="ml-2">Speichern</span>
                        <span v-else class="ml-2">Erstellen</span>
                    </v-btn>
                </v-row>
            </template>
            <template
                #EDIT_PACKAUFTRAEGE-buttons="{valid, save, value, action}">

                <v-row style="margin: 0; padding: 0;">


                    <v-spacer/>
                    <v-btn class="mb-2 aprocon-form--button aprocon-form--button-secondary"
                           :disabled="!valid" @click="printNve(value)">
                        <v-icon small class="mr-2">fa-barcode</v-icon>
                        <span class="ml-2">NVE-Etikett</span>
                    </v-btn>
                    <v-menu top left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                :disabled="!valid"
                                class="aprocon-form--button aprocon-form--button-secondary">
                                <v-icon small class="mr-2">fa-print</v-icon>
                                <span>Paket</span>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="printPaketaufkleber(1, value)">
                                <v-list-item-title  tag="a">
                                    Anzahl 1
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title tag="a" @click="printPaketaufkleber(2,value)">
                                    Anzahl 2
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title tag="a" @click="printPaketaufkleber(3, value)">
                                    Anzahl 3
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title tag="a" @click="printPaketaufkleber(4, value)">
                                    Anzahl 4
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="printPaketaufkleber(5, value)">
                                <v-list-item-title tag="a">
                                    Anzahl 5
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="printPaketaufkleber(0, value)">
                                <v-list-item-title tag="a">
                                    Manuelle Eingabe...
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu top left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="aprocon-form--button aprocon-form--button-primary"
                                   v-bind="attrs"
                                   v-on="on"
                                   :disabled="!valid">
                                <!--                        <v-icon small dark>fa-floppy-disk</v-icon>-->
                                <span v-if="action=='Update'" class="ml-2">Speichern</span>
                                <span v-else class="ml-2">Erstellen</span>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <v-list-item-title @click="setGeliefert(save)" tag="a">
                                    <v-icon size="16" style=" margin-right: 8px">
                                        fa-check
                                    </v-icon>
                                    Geliefert
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title @click="printLieferschein(save)" tag="a">
                                    <v-icon size="16" style="margin-top: -5px; margin-right: 8px">
                                        fa-print
                                    </v-icon>
                                    Lieferschein
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-title @click="savePackauftraegeOrder(save)" tag="a">
                                    <v-icon size="16"
                                            style="margin-top: -5px; margin-right: 8px; margin-left: 2px;">
                                        fa-save
                                    </v-icon>
                                    Speichern
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </template>

            <template #loading-overlay>
                <v-layout justify-center align-center fill-height>
                    <v-progress-circular indeterminate/>
                </v-layout>
            </template>
            <template v-for="tabItem in customTabSlots" #[tabItem.id]="{value}">
                <!-- v-for erzeugt hier Slot-Definitionen, keine Liste: ein key hätte keine Wirkung -->
                <!-- eslint-disable-next-line vue/require-v-for-key -->
                <div class="ma-4">
                    <component :is="tabItem.type"
                               :item-title-prop="tabItem.titleProp"
                               :search-label="tabItem.searchLabel"
                               :new-item-title="tabItem.newItemTitle"
                               :grid-name="tabItem.gridBrowse"
                               :parent-record-id="tabItem.parentRecordId(value)"
                               :parent-record="tabItem.parentRecord(value)"
                               :context="tabItem.buildContext(value)"
                               @edit="tabItem.OnEdit"
                               @delete="tabItem.OnDelete"
                               @add="tabItem.OnAdd"
                               :single-select-actions="tabItem.singleSelectActions"
                               :multi-select-actions="tabItem.multiSelectActions"
                               @formClosed="tabItem.OnEditTabTable"
                    >
                    </component>
                </div>
            </template>
        </aprocon-table>
        <article-history-dialog ref="articleHistoryDialog"/>
        <print-order-dialog ref="printOrderDialog"/>
        <anzahl-dialog ref="anzahlDialog" />
    </div>
</template>

<script lang="ts">
import {Component, Ref, Prop, Vue, Watch} from 'vue-property-decorator';
import {
    AproconFormDialog,
    AproconTable,
    ErrorHandler,
    FieldConfig, FormAction, FormConfig, FormErrorHandlerParams, FormErrorHandlerResponse,
    FormsMappingProvider,
    TableConfig, TableErrorHandlerParams, TableErrorHandlerResponse
} from '@aprocon-software/aprocon-form';
import {globalEventBus} from "@/main";
import FormDialog from "@/components/general/FormDialog.vue";
import FormMappingUtility from "@/assets/utils/FormMapperUtil";
import CustomerReports from "@/components/CustomerReports.vue";
import ArticleHistoryDialog from "@/components/ArticleHistoryDialog.vue";
import PrintOrderDialog from "@/components/general/PrintOrderDialog.vue";
import AnzahlDialog from "@/components/AnzahlDialog.vue";
import moment from "moment-mini";

@Component({
    components: {
        AnzahlDialog,
        PrintOrderDialog,
        ArticleHistoryDialog,
        CustomerReports,
        FormDialog,
        AproconTable,
        AproconFormDialog
    },
})
export default class GridForm extends Vue {

    private async printNve( data:any) {
        try{
            await this.saveForm();

                await this.$ports.orderManager.printNve(data);

                globalEventBus.$emit("showInfo", {
                    title: "Druck erfolgreich",
                    message: "Es wurde ein neues NVE-/Paletten-Etikett für den Auftrag erstellt und gedruckt."
                });


            //this.additionContextParameter = "SaveOption=2;";
            // await save();
        }catch(e:any) {
            globalEventBus.$emit("showError", e.message);
        }
    }
    private async printPaketaufkleber(anzahl:number, data:any) {
        try{
            await this.saveForm();
            if(anzahl > 0) {
                await this.$ports.orderManager.printPaketaufkleber(anzahl,data);

                globalEventBus.$emit("showInfo", {
                    title: "Druck erfolgreich",
                    message: "Es wurden " + anzahl + " Paketaufkleber gedruckt."
                });
            }else {
                // show Anzahl Dialog
                (<any>this.$refs.anzahlDialog).show((anzahlPrints:number)=>{
                    this.printPaketaufkleber(anzahlPrints, data);
                });
            }

            //this.additionContextParameter = "SaveOption=2;";
           // await save();
        }catch(e:any) {
            globalEventBus.$emit("showError", e.message);
        }
    }
    private async printLieferschein(save: any) {
        this.additionContextParameter = "SaveOption=2;";
        await save();
    }

    private async setGeliefert(save: any) {
        this.additionContextParameter = "SaveOption=1;";
        await save();
    }

    private async savePackauftraegeOrder(save: any) {
        this.additionContextParameter = "SaveOption=3;";
        await save();
    }

    private formLoaded(e: any, fa: FormAction): void {

        this.$emit("formLoaded", {form: e, formAction: fa});
    }

    public openItem(nummer: number) {
        this.table.editItem(nummer);
    }

    private bestellpositionenChanged: boolean = false;
    private auftragspositionenChanged: boolean = false;

    private async tabChanged(args: { formName: string, tab: string, isFirstLoad: boolean, form: any }): Promise<void> {
        //console.log("tabChnaged");
        //console.log(args.isFirstLoad);


        if (args.formName === 'EDIT_FILIALAUFTRAEGE') {
            if (args.tab === 'FILIALAUFTRAEGE_POSITIONEN') {
                //console.log('FILIALBESTELLUNGEN_POSITIONEN')
                if (await this.table.form.hasChanges()) {
                    await this.saveForm();
                    //this.bestellpositionenChanged = false;
                    //console.log("saveForm");
                }
            } else {

                //console.log("other tab");
                if (args.isFirstLoad) {
                    if (this.auftragspositionenChanged) {
                        this.table.form.reload();
                        //console.log("reloadForm");
                        this.auftragspositionenChanged = false;
                    }
                }
            }
        }

        if (args.formName === 'EDIT_PACKAUFTRAEGE') {
            console.log(args.tab);
            if (args.tab === 'PACKMANAGERFILIALBESTELLUNGEN_POSITIONEN' || args.tab === 'PACKMANAGERKUNDENBESTELLUNGEN_POSITIONEN') {
                globalEventBus.$emit("activatePositionScan",{});
                //console.log('FILIALBESTELLUNGEN_POSITIONEN')
                if (await this.table.form.hasChanges()) {
                    await this.saveForm();
                    //this.bestellpositionenChanged = false;
                    //console.log("saveForm");
                }
            } else {
                //console.log("other tab");
                if (args.isFirstLoad) {
                    if (this.bestellpositionenChanged) {
                        this.table.form.reload();
                        //console.log("reloadForm");
                        this.bestellpositionenChanged = false;
                    }
                }
            }
        }


        if (args.formName === 'EDIT_FILIALBESTELLUNGEN') {
            if (args.tab === 'FILIALBESTELLUNGEN_POSITIONEN') {
                //console.log('FILIALBESTELLUNGEN_POSITIONEN')
                if (await this.table.form.hasChanges()) {
                    await this.saveForm();
                    //this.bestellpositionenChanged = false;
                    //console.log("saveForm");
                }
            } else {
                //console.log("other tab");
                if (args.isFirstLoad) {
                    if (this.bestellpositionenChanged) {
                        this.table.form.reload();
                        //console.log("reloadForm");
                        this.bestellpositionenChanged = false;
                    }
                }
            }
        }

    }

    private async saveCustomerOrder(save: any): Promise<void> {
        await save();
    }

    private async saveOrder(save: any, action: string, value: any): Promise<void> {

        let checkValue = value;
        if (this.bestellpositionenChanged) {
            await this.table.form.reload();
            checkValue = this.table.form.getData();
            //console.log(checkValue);
        }

        if (checkValue["LOCAL_POSITIONENMITBESTELLMENGE"] === 0) {
            globalEventBus.$emit("showConfirm", {
                title: "Bestellung erstellen?",
                message: "<p>Sie haben noch keine Bestellmengen eingegeben. Soll die Bestellung trotzdem geschlossen werden?.</p>",
                confirmationCallback: async () => {
                    try {
                        this.loading = true;
                        await save();
                    } catch (e: any) {
                        globalEventBus.$emit("showError", e.message);
                    } finally {
                        this.loading = false;
                    }
                }
            });
        } else {
            await save();
        }
        this.bestellpositionenChanged = false;
    }

    private loading: boolean = false;

    private canPrint(value: any): boolean {
        return value["HAUPTAUFTRAG"] > 0 && value["DATUM"] !== "";
    }

    private canSend(value: any): boolean {
        const lieferdatum = moment(value["DATUM"], "DD.MM.YYYY").toDate();
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        //&& now <= lieferdatum
        return value["LOCAL_HALFR:STATUS"] === 1 && value["LOCAL_POSITIONENMITBESTELLMENGE"] > 0 && (value["LOCAL_OFFENEPFLICHTARTIKEL"] === 0 || value["LOCAL_OFFENEPFLICHTARTIKEL"] === "0") && now <= lieferdatum;
    }

    private async sendOrder(changed: boolean, value: any, save: any, cancel: any): Promise<void> {
        globalEventBus.$emit("showConfirm", {
            title: "Bestellung abschicken?",
            message: "<p>Möchten Sie die Bestellung abschicken?</p><p>Danach kann die Bestellung nicht mehr verändert werden.</p>",
            confirmationCallback: async () => {
                try {
                    this.loading = true;
                    if (changed) {
                        await this.table.saveForm();
                    }
                    const message = await this.$ports.branchOrder.sendOrder(value);
                    globalEventBus.$emit("showInfo", {
                        title: "Bestellung erfolgreich",
                        message: message
                    });
                    await save();
                } catch (e: any) {
                    globalEventBus.$emit("showError", e.message);
                } finally {
                    this.loading = false;
                }
            }
        });
    }

    private async printOrder(changed: boolean, value: any, cancel: any): Promise<void> {

        if (value["LOCAL_POSITIONENMITBESTELLMENGE"] > 0) {
            (<any>this.$refs.printOrderDialog).showDialog(async () => {
                try {
                    this.loading = true;
                    const file = await this.$ports.branchOrder.printOrder(value, true);
                    await this.downloadFile(file);
                } catch (e: any) {
                    globalEventBus.$emit("showError", e.message);
                } finally {
                    this.loading = false;
                }
            }, async () => {
                try {
                    this.loading = true;
                    const file = await this.$ports.branchOrder.printOrder(value, false);
                    await this.downloadFile(file);
                } catch (e: any) {
                    globalEventBus.$emit("showError", e.message);
                } finally {
                    this.loading = false;
                }
            });
        } else {
            try {
                this.loading = true;
                const file = await this.$ports.branchOrder.printOrder(value, true);
                await this.downloadFile(file);
            } catch (e: any) {
                globalEventBus.$emit("showError", e.message);
            } finally {
                this.loading = false;
            }
        }
    }

    private async downloadFile(file: string): Promise<void> {
        // const fileRes = await fetch(file);
        // const fileBlob = await fileRes.blob();
        // const url = window.URL.createObjectURL(fileBlob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = file;
        a.target = '_blank';

        // the filename you want
        //a.download = file;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // window.URL.revokeObjectURL(url);
    }

    @Ref('articleHistoryDialog')
    private articleHistoryDialog!: any;

    @Ref('saveChangesDialog')
    private saveChangesDialog!: any;
    private customTabSlots: any[] = [];
    private preiseFilter: string = '';
    private preiseGridName: string = "BROWSE_KUNDENPREISE";

    private preiseContext(parent: any): string {
        return this.context;
    }

    private preiseParentId(item: any): number {
        return item.NUMMER;
    }

    public async setFilter(filter: string): Promise<void> {
        this.filter = filter;

    }

    private rechnungenFilter: string = '';
    private rechnungenGridName: string = "BROWSE_RECHNUNGEN";

    private rechnungenContext(parent: any): string {
        return this.context;
    }

    private rechnungenParentId(item: any): number {
        return item.NUMMER;
    }

    private kontakteFilter: string = '';
    private kontakteGridName: string = "BROWSE_KONTAKTE";

    private kontakteContext(parent: any): string {
        return this.context;
    }

    private kontakteParentId(item: any): number {
        return item.NUMMER;
    }

    private auftraegeFilter: string = '';
    private auftraegeGridName: string = "BROWSE_AUFTRAEGE";

    private auftraegeContext(parent: any): string {
        return this.context;
    }

    private auftraegeParentId(item: any): number {
        return item.NUMMER;
    }

    @Prop({default: undefined})
    private tableConfigs!: Map<string, any> | undefined;

    public async setActiveTab(index: number): Promise<void> {
        //console.log(this.table);
        await this.table?.form?.setActiveTab(index);
    }

    private async editItem(args: { id: any, tableName: string }): Promise<void> {
        //console.log('editItem');
        this.$emit('edit', args);
    }

    private async deleteItem(): Promise<void> {
        //console.log('deleteItem');
        this.$emit('delete');
    }

    private async formClosed(args: { tableName: string, id: number | string | undefined, action: 'Create' | 'Update' | 'View' | 'Delete' }): Promise<void> {
        //console.log('formClosed');
        this.additionContextParameter = "";
        this.$emit("formClosed", args);
    }

    private overrideConfig(tableConfig: TableConfig): TableConfig {
        tableConfig.fixedHeader = true;
        tableConfig.fixedFooter = true;


        if (tableConfig.tableName === this.gridName) {
            this.createPermission = tableConfig.permissions.create;
            // tableConfig.multiselect = this.multiSelect;
            tableConfig.multiselectActions = this.multiSelectActions;
            tableConfig.actions = this.singleSelectActions;
            return tableConfig;
        }

        if (this.tableConfigs) {
            if (this.tableConfigs.has(tableConfig.tableName)) {
                const config = this.tableConfigs.get(tableConfig.tableName);
                tableConfig.multiselectActions = config.multiSelectActions;
                tableConfig.actions = config.singleSelectActions;
                if (config.fixedFooter !== undefined) {
                    tableConfig.fixedFooter = config.fixedFooter;
                }
                if (config.fixedHeader !== undefined) {
                    tableConfig.fixedHeader = config.fixedHeader;
                }
            }
        }
        return tableConfig;
    }

    @Prop()
    private parentRecordId!: number | undefined;
    @Prop()
    private parentRecord!: any | undefined;
    @Prop({
        default: () => {
            return FormMappingUtility.formMappingProvider;
        }
    })
    private formMapper!: any;
    /*Props*/
    @Prop({default: true})
    private openDefaultForm!: boolean;
    @Prop({required: true, default: 'BEZEICHNUNG'})
    private itemTitleProp!: string;
    @Prop({required: true, default: 'Neuer Eintrag'})
    private newItemTitle!: string;

    @Prop({required: true})
    private gridName!: string;
    @Prop({required: false, default: false})
    private showBackButton!: boolean;
    @Prop({required: false, default: false})
    private showRefreshButton!: boolean;
    @Prop({required: false, default: false})
    private disableRefreshButton!: boolean;
    @Prop()
    private goBackCallback!: any;
    @Prop()
    private refreshCallback!: any;
    @Prop({default: 'Suchen'})
    private searchLabel!: string;
    @Prop({
        default: () => {
            return [];
        }
    })
    @Prop({default: []})
    private multiSelectActions!: any[];

    @Prop({
        default: () => {
            return [];
        }
    })
    private singleSelectActions!: any[];


    /*Refs*/
    @Ref()
    private readonly form!: AproconFormDialog;
    @Ref('table')
    private readonly table!: AproconTable<any>;


    // Das Expression-Objekt selbst merken, nicht .value: aprocon-form wertet Ausdrücke
    // erst nach overrideConfig aus und schreibt das Ergebnis in dieses Objekt.
    private createPermission: { value: boolean } | null = null;

    private get canCreate(): boolean {
        return !!this.createPermission?.value;
    }

    @Prop()
    private filterExpression!: string | null;

    public clearSelection(): void {
        this.table.clearSelection();
    }

    private filter: string = '';
    private formName: string = '';
    private editRecord: any = {};
    private formAction: 'Create' | 'View' | 'Update' | 'Delete' = 'View';
    private errorHandler: ErrorHandler = {
        handleTableConfigError: this.handleTableError,
        handleTableLoadError: this.handleTableError,
        handleTableUnknownError: this.handleTableError,
        handleFormConfigError: this.handleFormError,
        handleFormLoadError: this.handleFormError,
        handleFormSaveError: this.handleFormError,
        handleFormUnknownError: this.handleFormError
    };
    /*Computed Props*/
    // private get editRecordId(): number | null {
    //     return this.editRecord?.RECORDID;
    // }
    public static formMapperDefault(): any {

        return {
            mapField(field: FieldConfig, raw: any): FieldConfig {

                //
                return field;
            },
            mapForm: (form: FormConfig, raw: any) => {

                return form;
            },
        };
    }

    @Prop({required: true})
    private context!: string;


    private additionContextParameter: string = "";

    private get gridContext(): string {
        if (this.context.startsWith(`Filiale=${this.$store.getters["Auth/branchId"]};`)) {

            return this.context;
        }

        return `Filiale=${this.$store.getters["Auth/branchId"]};` + this.context;
    }

    /*Watcher*/
    @Watch('context')
    private contextChanged(): void {

    }

    private get simpleFormContext(): string {
        if (this.additionContextParameter) {
            return this.gridContext + this.additionContextParameter;
        }
        return this.gridContext;
    }

    /*Methods*/
    private formContext(): { [key: string]: string } {
        return {'EDIT_ETIKETTENTEXTE': this.context + ',' + this.filterExpression}
    }

    public async refreshForm(): Promise<void> {
        return this.table.reloadForm();
    }

    public async refresh(full: boolean): Promise<void> {
        return this.table.reload(full);
    }


    private cancel(): void {
        this.$emit('cancel');
    }

    private async handleFormError(params: FormErrorHandlerParams): Promise<FormErrorHandlerResponse> {
        if (params.error) {
            //console.log(params.error);
            // logout
            if (params.error.id && params.error.id === 10003) {
                await this.$store.commit("Auth/setAuthToken", '');
                await this.$ports.auth.logout();
            }
            if (params.error.message) {
                await globalEventBus.$emit('showError', params.error.message);
            } else {
                await globalEventBus.$emit('showError', params.error);
            }
        }
        return {
            closeForm: true
        }
    }

    private async handleTableError(params: TableErrorHandlerParams): Promise<TableErrorHandlerResponse> {
        if (params.error) {

            console.log(params.error);
            // logout
            if (params.error.id && params.error.id === 10003) {
                await this.$store.commit("Auth/setAuthToken", '');
                await this.$ports.auth.logout();
            }
            if (params.error.message) {
                await globalEventBus.$emit('showError', params.error.message);
            } else {
                await globalEventBus.$emit('showError', params.error);
            }

            try {
                //await this.table.form.close();
            } catch (e) {
                console.log(e);
            }
        }
        return {};
        //this.cancel();
    }

    public async addItem(): Promise<void> {
        this.formAction = 'Create';
        //console.log('addItem');
        this.$emit('add');
        await this.table.createItem();

    }


    private goBack(): void {
        if (this.goBackCallback) {
            this.goBackCallback();
        } else {
            this.$router.back();
        }
    }

    private async refreshGrid(): Promise<void> {
        if (this.refreshCallback) {
            await this.refreshCallback();
        } else {
            await this.table.reload(false);
        }
    }

    private clickRow(args: { value: any, id: any, formName: string, tableName: string }): void {
        //this.$emit('rowItemClick', args);
    }

    public async saveForm(): Promise<void> {
        if (await this.table.form.hasChanges()) {
            await this.table.form.save();
        }
    }

    public get formMappingProvider(): FormsMappingProvider {
        return {
            mapForm: (form: FormConfig, raw: any) => {
                if (this.customTabSlots.length === 0) {
                    this.customTabSlots = [
                        //ARTIKEL
                        {
                            id: 'tab-ARTIKEL_PREISE',
                            title: 'Preise',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Preise durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_ARTIKELPREISE',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        {
                            id: 'tab-ARTIKEL_BERICHTE',
                            title: 'Berichte',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: '',
                            searchLabel: '',
                            newItemTitle: '',
                            gridBrowse: '',
                            type: () => import ("@/components/ProductReports.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        //ARTIKELPREISE
                        {
                            id: 'tab-ARTIKELPREISE_PREISVERLAUF',
                            title: 'Preisverlauf',
                            context: '',
                            buildContext: (item: any) => {
                                return `PREISKATEGORIE=${item.PREISKATEGORIE};KUNDE=${item.KUNDE}`;
                            },
                            parentRecordId: (item: any) => {
                                return item.ARTIKEL;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Preisverlauf durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_ARTIKELPREISE',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        }, //AUFTRAEGE
                        {
                            id: 'tab-AUFTRAEGE_POSITIONEN',
                            title: 'Positionen',
                            context: 'Belegart=Bestellung',
                            buildContext: (item: any) => {
                                return `Belegart=Bestellung`;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Positionen durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_AUFTRAGSPOSITIONEN',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [{
                                icon: "<i class='ordermanager-bill-credit-card'></i>",
                                displayName: 'Liefermengen übernehmen',
                                action: async (entries: any[], config: TableConfig) => {
                                    globalEventBus.$emit("loadingChanges", {loading: true});
                                    globalEventBus.$emit("showConfirm", {
                                        title: "Liefermengen",
                                        message: "Für die gewählten Positionen werden die Liefermengen anhand der Bestellmengen eingetragen." +
                                            "Soll diese Aktion jetzt gestartet werden?",
                                        confirmationCallback: async () => {
                                            try {

                                                const selected: { Nummer: number }[] = [];
                                                entries.forEach(
                                                    (e) => {
                                                        selected.push({Nummer: e.id});
                                                    })

                                                try {
                                                    const message = await this.$ports.orderManager.acceptOrderQuantities(selected);
                                                    globalEventBus.$emit("showInfo", {
                                                        title: "Aufträge",
                                                        message: message
                                                    });

                                                } catch (e: any) {
                                                    globalEventBus.$emit("showError", e.message);
                                                } finally {
                                                    await this.refreshGrid();
                                                }
                                            } catch (e: any) {
                                                globalEventBus.$emit("showError", e.message);
                                            } finally {
                                                globalEventBus.$emit("loadingChanges", {loading: false});
                                            }
                                        }
                                    });
                                },
                                enabled: () => true
                            }],
                            OnEditTabTable: () => {
                                this.table.form.reload();
                                console.log('OnEditTabTable');
                            },
                            OnEdit: () => {
                                this.saveForm();
                                console.log('OnEditTabTable-edit');
                            },
                            OnDelete: () => {
                                this.saveForm();
                                console.log('OnEditTabTable-delete');
                            },
                            OnAdd: () => {
                                this.saveForm();
                                console.log('OnEditTabTable-add');
                            }
                        },
                        //PACKMANAGER Filialaufträge
                        {
                            id: 'tab-PACKMANAGERFILIALBESTELLUNGEN_POSITIONEN',
                            title: 'Positionen',
                            context: "",
                            buildContext: (item: any) => {
                                return "Belegart=Filialbestellung;";
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {

                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Positionen durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_PACKAUFTRAGSPOSITIONEN',
                            type: () => import("@/components/general/BestellpositionenGridForm_Packmanager.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                                this.auftragspositionenChanged = true;
                                //this.table.form.reload();
                                //console.log('OnEditTabTable');
                            },
                            OnEdit: () => {
                                this.auftragspositionenChanged = true;
                                //this.saveForm();
                                //console.log('OnEditTabTable-edit');
                            },
                            OnDelete: () => {
                                //this.saveForm();
                                this.auftragspositionenChanged = true;
                                //console.log('OnEditTabTable-delete');
                            },
                            OnAdd: () => {
                                //this.saveForm();
                                this.auftragspositionenChanged = true;
                                //console.log('OnEditTabTable-add');
                            }
                        },
                        //PACKMANAGER Kundenaufträge
                        {
                            id: 'tab-PACKMANAGERKUNDENBESTELLUNGEN_POSITIONEN',
                            title: 'Positionen',
                            context: "",
                            buildContext: (item: any) => {
                                return `Belegart=Kundenbestellung;`;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Positionen durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_PACKAUFTRAGSPOSITIONEN',
                            type: () => import("@/components/general/BestellpositionenKundenauftraegeGridForm_Packmanager.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                                this.auftragspositionenChanged = true;
                                //this.table.form.reload();
                                //console.log('OnEditTabTable');
                            },
                            OnEdit: () => {
                                this.auftragspositionenChanged = true;
                                //this.saveForm();
                                //console.log('OnEditTabTable-edit');
                            },
                            OnDelete: () => {
                                //this.saveForm();
                                this.auftragspositionenChanged = true;
                                //console.log('OnEditTabTable-delete');
                            },
                            OnAdd: () => {
                                //this.saveForm();
                                this.auftragspositionenChanged = true;
                                //console.log('OnEditTabTable-add');
                            }
                        },
                        //FILIALAUFTRAEGE
                        {
                            id: 'tab-FILIALAUFTRAEGE_POSITIONEN',
                            title: 'Positionen',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Positionen durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_FILIALAUFTRAGSPOSITIONEN',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                                this.auftragspositionenChanged = true;
                                //this.table.form.reload();
                                //console.log('OnEditTabTable');
                            },
                            OnEdit: () => {
                                this.auftragspositionenChanged = true;
                                //this.saveForm();
                                //console.log('OnEditTabTable-edit');
                            },
                            OnDelete: () => {
                                //this.saveForm();
                                this.auftragspositionenChanged = true;
                                //console.log('OnEditTabTable-delete');
                            },
                            OnAdd: () => {
                                //this.saveForm();
                                this.auftragspositionenChanged = true;
                                //console.log('OnEditTabTable-add');
                            }
                        },
                        //FILIALBESTELLUNGEN
                        {
                            id: 'tab-FILIALBESTELLUNGEN_POSITIONEN',
                            title: 'Artikel',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Artikel durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_FILIALBESTELLUNGSPOSITIONEN',
                            type: () => import("@/components/general/BestellpositionenGridForm.vue"),
                            singleSelectActions: [{
                                action: async (entry: any, config: TableConfig) => {

                                    //alert(entry.ART_NUMMER);
                                    //globalEventBus.$emit("loadingChanges", {loading: true});
                                    //console.log(entry);
                                    //console.log(config);
                                    this.articleHistoryDialog.show(entry, config.permissions.update.value);
                                },
                                displayName: 'Historie',
                                icon: "<i class='ordermanager-order'></i>"

                            }],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                                this.bestellpositionenChanged = true;

                            },
                            OnEdit: () => {
                                this.bestellpositionenChanged = true;

                            },
                            OnDelete: () => {
                                this.bestellpositionenChanged = true;
                            },
                            OnAdd: () => {
                                this.bestellpositionenChanged = true;
                            }
                        },
                        //KUNDEN_EX
                        {
                            id: 'tab-KUNDEN_EX_KONTAKTE',
                            title: 'Kontakte',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Kontakte durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_KONTAKTE',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        {
                            id: 'tab-KUNDEN_EX_STAMMARTIKEL',
                            title: 'Stammartikel',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Stammartikel durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_STAMMARTIKEL',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [
                                {
                                    action: async (entries: any[], config: TableConfig) => {

                                        globalEventBus.$emit("loadingChanges", {loading: true});
                                        globalEventBus.$emit("showConfirm", {
                                            title: "Bestellung",
                                            message: "Möchten Sie anhand der selektierten Artikel eine neue Bestellung anlegen?",
                                            confirmationCallback: () => this.doBestellungAusStammArtikeln(entries)
                                        });
                                    },
                                    displayName: 'Bestellung',
                                    icon: "<i class='ordermanager-order'></i>"
                                }
                            ],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        {
                            id: 'tab-KUNDEN_EX_AUFTRAEGE',
                            title: 'Auftraege',
                            context: 'Belegart=Bestellung',
                            buildContext: (item: any) => {
                                return `Belegart=Bestellung`;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Aufträge durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_AUFTRAEGE',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        {
                            id: 'tab-KUNDEN_EX_RECHNUNGEN',
                            title: 'Rechnungen',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Rechnungen durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_RECHNUNGEN',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        {
                            id: 'tab-KUNDEN_EX_PREISE',
                            title: 'Preise',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Preise durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_KUNDENPREISE',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        {
                            id: 'tab-KUNDEN_EX_BERICHTE',
                            title: 'Berichte',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Berichte durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_BERICHTE',
                            type: () => import ("@/components/CustomerReports.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                            },
                            OnEdit: () => {
                            },
                            OnAdd: () => {
                            },
                            OnDelete: () => {
                            }
                        },
                        //RECHNUNGEN
                        {
                            id: 'tab-RECHNUNGEN_POSITIONEN',
                            title: 'Positionen',
                            context: '',
                            buildContext: (item: any) => {
                                return ``;
                            },
                            parentRecordId: (item: any) => {
                                return item.NUMMER;
                            },
                            parentRecord: (item: any) => {
                                return item;
                            },
                            titleProp: 'SUCHBEGRIFF',
                            searchLabel: 'Positionen durchsuchen',
                            newItemTitle: '',
                            gridBrowse: 'BROWSE_RECHNUNGSPOSITIONEN',
                            type: () => import("@/components/general/GridForm.vue"),
                            singleSelectActions: [],
                            multiSelectActions: [],
                            OnEditTabTable: () => {
                                this.table.form.reload();
                                console.log('OnEditTabTable');
                            },
                            OnEdit: () => {
                                this.saveForm();
                                console.log('OnEditTabTable-edit');
                            },
                            OnDelete: () => {
                                this.saveForm();
                                console.log('OnEditTabTable-delete');
                            },
                            OnAdd: () => {
                                this.saveForm();
                                console.log('OnEditTabTable-add');
                            }
                        }
                    ];
                }
                if (form.formName === 'EDIT_ARTIKEL') {

                    form.sheets.push({
                        id: 'ARTIKEL_PREISE',
                        title: 'Preise',
                        order: 10,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                    form.sheets.push({
                        id: 'ARTIKEL_BERICHTE',
                        title: 'Berichte',
                        order: 11,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                }
                if (form.formName === 'EDIT_ARTIKELPREISE') {
                    form.sheets.push({
                        id: 'ARTIKELPREISE_PREISVERLAUF',
                        title: 'Preisverlauf',
                        order: 12,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                }
                if (form.formName === 'EDIT_AUFTRAEGE') {
                    form.sheets.push({
                        id: 'AUFTRAEGE_POSITIONEN',
                        title: 'Positionen',
                        order: 13,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                }
                if (form.formName === 'EDIT_FILIALBESTELLUNGEN') {
                    form.sheets.push({
                        id: 'FILIALBESTELLUNGEN_POSITIONEN',
                        title: 'Positionen',
                        order: 13,
                        hidden: {
                            expression: 'NOT({HAUPTAUFTRAG}<>0 AND {DATUM}<>0)',
                            triggeredByFields: ['HAUPTAUFTRAG', 'DATUM'],
                            value: false
                        },
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                }
                if (form.formName === 'EDIT_PACKAUFTRAEGE') {
                    if (this.context.includes("Belegart=Filialbestellung")) {
                        form.sheets.push({
                            id: 'PACKMANAGERFILIALBESTELLUNGEN_POSITIONEN',
                            title: 'Positionen',
                            order: 13,
                            hidden: {expression: '', triggeredByFields: [], value: false},
                            disabled: {expression: '', triggeredByFields: [], value: false},
                        });
                    } else {
                        form.sheets.push({
                            id: 'PACKMANAGERKUNDENBESTELLUNGEN_POSITIONEN',
                            title: 'Positionen',
                            order: 13,
                            hidden: {expression: '', triggeredByFields: [], value: false},
                            disabled: {expression: '', triggeredByFields: [], value: false},
                        });
                    }
                }
                if (form.formName === 'EDIT_FILIALAUFTRAEGE') {
                    form.sheets.push({
                        id: 'FILIALAUFTRAEGE_POSITIONEN',
                        title: 'Positionen',
                        order: 13,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                }
                if (form.formName === 'EDIT_KUNDEN_EX') {
                    form.sheets.push({
                        id: 'KUNDEN_EX_KONTAKTE',
                        title: 'Kontakte',
                        order: 14,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                    form.sheets.push({
                        id: 'KUNDEN_EX_STAMMARTIKEL',
                        title: 'Stammartikel',
                        order: 15,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                    form.sheets.push({
                        id: 'KUNDEN_EX_AUFTRAEGE',
                        title: 'Aufträge',
                        order: 16,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                    form.sheets.push({
                        id: 'KUNDEN_EX_RECHNUNGEN',
                        title: 'Rechnungen',
                        order: 17,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                    form.sheets.push({
                        id: 'KUNDEN_EX_PREISE',
                        title: 'Preise',
                        order: 18,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                    form.sheets.push({
                        id: 'KUNDEN_EX_BERICHTE',
                        title: 'Berichte',
                        order: 19,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                }
                if (form.formName === 'EDIT_RECHNUNGEN') {
                    form.sheets.push({
                        id: 'RECHNUNGEN_POSITIONEN',
                        title: 'Positionen',
                        order: 20,
                        hidden: {expression: '', triggeredByFields: [], value: false},
                        disabled: {expression: '', triggeredByFields: [], value: false},
                    });
                }
                return form;
            },
            mapField: this.mapField
        }
    }

    private mapField(field: FieldConfig, raw: any): FieldConfig {
        if (raw.TYPE === "EDIT") {
            if (raw.NAME === "SCAN") {
                field.fieldType = () => import("@/components/CustomFormControls/LieferdatumFormField.vue");
                field.inputType = () => import("@/components/CustomFormControls/LieferdatumFormInput.vue");
                return field;
            }
        }
        if (raw.TYPE === "CALENDAR") {
            if (raw.NAME === "DATUM") {
                field.fieldType = () => import("@/components/CustomFormControls/LieferdatumFormField.vue");
                field.inputType = () => import("@/components/CustomFormControls/LieferdatumFormInput.vue");
                return field;
            } else {
                field.fieldType = () => import("@/components/CustomFormControls/DateFormField.vue");
                field.inputType = () => import("@/components/CustomFormControls/DateFormInput.vue");
                return field;
            }
        }
        if (raw.TYPE === "CLOCK") {
            field.fieldType = () => import("@/components/CustomFormControls/TimeFormField.vue");
            field.inputType = () => import("@/components/CustomFormControls/TimeFormInput.vue");
            return field;
        }
        return field;
    }

    private async doBestellungAusStammArtikeln(entries: any[]): Promise<void> {

        try {

            const selected: { Nummer: number }[] = [];
            entries.forEach(
                (e) => {
                    selected.push({Nummer: e.id});
                })

            try {
                const response = await this.$ports.orderManager.createOrderByArticles(selected);
                if (response && response.UserMessage) {
                    try {
                        await this.table.cancelForm();
                        globalEventBus.$emit('showConfirm', {
                            title: 'Bestellung',
                            message: response.UserMessage,
                            confirmationCallback: async () => {
                                await this.$router.replace({
                                    path: "/filialauftraege",
                                    query: {filter: response.AuftragNr}
                                });
                            }
                        });
                    } catch (e: any) {
                        console.log(e);
                    }
                }
            } catch (e: any) {
                globalEventBus.$emit("showError", e.message);
            } finally {
                //await this.refreshGrid();
            }
        } catch (e: any) {
            globalEventBus.$emit("showError", e.message);
        } finally {
            globalEventBus.$emit("loadingChanges", {loading: false});
        }
    }

    public async formClose(): Promise<void> {
        try {
            console.log("formClose");
            await this.table.form.close();
        } catch (e: any) {
            console.log(e);
        }
    }
}
</script>
<style type="text/css">
#app .aprocon-form--content-svg-tooltip {
    white-space: nowrap;
}
</style>
